import React from 'react'
import logo_pipal from '../assets/img/logo_pipal.png';



export default function Header () {



  return (
    <nav className="navbar navbar-light" Style="background-color: #edf0f1;">
     <div className="container-fluid ">  
        <div className="col-12 d-flex justify-content-left align-items-center">
        <a href='https://www.educacioncba.edu.ar'>
                    <img 
                        src= {logo_pipal} 
                        className="d-inline-block align-text-top brand-logo mt-2"
                    />
        </a>
        </div> 
      </div>
    </nav>
  )
}
